module.exports = __webpack_public_path__ + "static/media/po-control-valve.eb3b0709.png";